export { default as queryFragment } from './query-fragment';
